import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocuments = createSelector(
  [
    (store: RootState) => store.locationShow.documents,
    (store: RootState) => store.locationShow.documentSearchText,
  ],
  (documents, searchText) =>
    (documents || []).filter(({ title }) =>
      title?.toLowerCase().includes((searchText || "").toLowerCase() || "")
    )
);
